import React, { useEffect } from 'react';
import axios from 'axios';

export default function IRecBillingManagement() {

	const redirectToIRecUrl = async () => {
		const { data } = await axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/url/irec`);
		window.location.replace(data?.url);
	};

	useEffect(() => {
		redirectToIRecUrl();
	}, []);

	return <div></div>;
}
